import { LoginCallback } from '@okta/okta-react';
import { Spinner } from 'react-bootstrap';

/** OKTA redirect lands here; the SDK exchanges the code then restores the original URI. */
export default function LoginCallbackPage() {
  return (
    <LoginCallback
      loadingElement={
        <div className="text-center py-5">
          <Spinner animation="border" />
        </div>
      }
    />
  );
}
